/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { BaseButton } from '#UNSAFE_BaseButton';
import { Text } from '#UNSAFE_Text';
import { useTranslationBundle } from '#hooks/UNSAFE_useTranslationBundle';
import type { BundleType } from '#resources/nls/bundle';
import { clearButtonStyles } from './themes/ClearSelection.css';

type Props = {
  onAction: () => void;
};

/**
 * Clear selection button component
 */
export const ClearSelectionButton = ({ onAction }: Props) => {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const clearSelectionLabel = `${translations.vis_clearSelection()}`;
  return (
    <div class={clearButtonStyles.base}>
      <BaseButton
        styling={['default']}
        elementDetails={{ type: 'span', isFocusable: false, isLabel: true }}
        variant="outlined"
        onAction={onAction}>
        <Text truncation={'ellipsis'} weight={'inherit'}>
          {clearSelectionLabel}
        </Text>
      </BaseButton>
    </div>
  );
};
